// src/DebugNavWatcher.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Debug component to track all route changes and identify the source of navigation.
 * Local development only: in a real build it logged a stack trace on every page change and a false
 * console error on /employer/company-setup (formerly /employer/onboarding; 2026-10-10 verification sweep), so it does nothing there.
 */
export default function DebugNavWatcher() {
  const location = useLocation();

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    console.log("[NAV] route changed:", location.pathname);
    console.trace("[NAV] stack trace for route change:");
    if (location.pathname === "/employer/company-setup") {
      console.warn("[NAV] navigated to /employer/company-setup (see the stack trace above for the source).");
    }
  }, [location.pathname]);

  return null;
}
